import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import SrvButton from '../../../components/global/SrvButton';

function ChangedModal({ list, compnaySelectedId, editHandler }) {


    const stateCompanyList = useSelector((state) => state.companyList);

    return (
        <>
            {stateCompanyList.changed === true &&
                stateCompanyList.changedThis === false &&
                <Modal show={true}   >
                    <Modal.Body>
                        <div className='fs-5 text-center '>
                            <b>Компания по умолчанию изменена!</b>
                        </div>
                        <div className='fs-5 text-center mt-10 '>
                            Для продолжения обновите страницу
                        </div>
                        <div className='text-center mt-10 ' >
                            <SrvButton typeBtn="update" size='lg' textBtn='Обновить' onClick={() => { window.location.reload() }} />
                        </div>
                    </Modal.Body>
                </Modal>
            }
        </>
    );
}

export default ChangedModal;
